import React from "react";
import {Fade} from "react-reveal";
import "./MissionLab.scss";

const labExperiments = [
  {
    number: "01",
    eyebrow: "GUIDANCE + CONTROL",
    title: "Docking Simulator",
    description: "Pilot a spacecraft through the final approach.",
    route: "#/docking-simulator",
    action: "Launch simulator",
    icon: "⌖"
  },
  {
    number: "02",
    eyebrow: "COMMS + CHAOS",
    title: "Space Meme Generator",
    description: "Turn mission stress into mission control-approved comedy.",
    route: "#/space-meme-generator",
    action: "Generate memes",
    icon: "✦"
  },
  {
    number: "03",
    eyebrow: "SIGNALS + SECRETS",
    title: "Signal Decoder",
    description: "Find the carrier. Clear the static. Decode a deep-space transmission.",
    route: "#/signal-decoder",
    action: "Intercept signal",
    icon: "∿"
  },
  {
    number: "04",
    eyebrow: "ORBITS + DISCOVERY",
    title: "Orbit Playground",
    description: "Build an orbit, plan a burn, and follow your curiosity through a living planetary system.",
    route: "#/orbit-playground",
    action: "Enter the sandbox",
    icon: "◎"
  }
];

export default function MissionLab() {
  const openExperiment = (event, route) => {
    event.preventDefault();
    window.location.hash = route;
    window.location.reload();
  };

  return (
    <Fade bottom duration={900} distance="20px">
      <section className="mission-lab main" id="mission-lab">
        <div className="mission-lab-header">
          <div>
            <p className="mission-lab-kicker">INTERACTIVE FLIGHT SOFTWARE</p>
            <h1>Mission Lab</h1>
          </div>
          <p>Small experiments built for curious operators.</p>
        </div>

        <div className="mission-lab-grid">
          {labExperiments.map(experiment => (
            <a
              className="mission-lab-card"
              href={experiment.route}
              key={experiment.number}
              onClick={event => openExperiment(event, experiment.route)}
            >
              <span className="mission-lab-number">LAB / {experiment.number}</span>
              <span className="mission-lab-icon" aria-hidden="true">{experiment.icon}</span>
              <div>
                <p>{experiment.eyebrow}</p>
                <h2>{experiment.title}</h2>
                <span className="mission-lab-description">{experiment.description}</span>
              </div>
              <span className="mission-lab-action">{experiment.action} <b>↗</b></span>
            </a>
          ))}
        </div>
      </section>
    </Fade>
  );
}
